import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";

export const getSaleProducts = async ({
  page = 1,
  limit = 20,
  name,
  sector,
  isActive,
  costStatus,
  signal,
} = {}) => {
  const query = qs({
    page,
    limit,
    name,
    sector,
    isActive,
    costStatus,
  });
  return httpClient.get(`/stock/sale-products${query}`, { signal });
};

function requiredId(value, label) {
  const id = Number(value);
  if (!Number.isSafeInteger(id) || id <= 0) {
    throw new Error(`El ID ${label} es requerido`);
  }
  return id;
}

export const getSaleProduct = async (saleProductId, { signal } = {}) => {
  const id = requiredId(saleProductId, "del producto de venta");
  return httpClient.get(`/stock/sale-products/${id}`, { signal });
};

export const calculateSaleProductCost = async (data, { signal } = {}) =>
  httpClient.post("/stock/sale-products/calculate-cost", data, { signal });

export const createSaleProduct = async (data) =>
  httpClient.post("/stock/sale-products", data);

export const updateSaleProduct = async (saleProductId, data) => {
  const id = requiredId(saleProductId, "del producto de venta");
  return httpClient.patch(`/stock/sale-products/${id}`, data);
};

export const updateSaleProductActive = async (saleProductId, isActive) => {
  const id = requiredId(saleProductId, "del producto de venta");
  return httpClient.patch(`/stock/sale-products/${id}/active`, { isActive });
};

export const deleteSaleProduct = async (saleProductId) => {
  const id = requiredId(saleProductId, "del producto de venta");
  return httpClient.delete(`/stock/sale-products/${id}`);
};
